import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { ClipLoader } from 'react-spinners';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import Pagination from '../pagination/pagination';
import { useSelector } from 'react-redux';
import { getName, getUserId, getUserName } from '../../../Redux/selecters';
import LeaseApiService from '../../services/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { FaFileCircleExclamation } from "react-icons/fa6";
import CheckboxSetFilter from '../gridFilter/checkboxSetFilter';
import { useTranslation } from 'react-i18next';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const LeaseInvoiceApproval = () => {
    const { t } = useTranslation(['invoiceApproval', 'common']);
    const [searchTerm, setSearchTerm] = useState({ value: 'Pending', label: 'Pending' });
    const [rowData, setRowData] = useState([]);
    const [loader, setloader] = useState(false);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [POTab, setPOTab] = useState(true);
    const userName = useSelector(getUserId);
    const Name = useSelector(getUserName);
    const apiService = new LeaseApiService();

    const [colDefs, setColDefs] = useState([]);
    const [selectedItems, setSelectedItems] = useState([])
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const location = useLocation();
    const navigate = useNavigate();
    const leaseData = location.state;

    const [formData, setFormData] = useState({
        leaseNo: "",
    });
    const StatusFilter = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Rejected', label: 'Rejected' },
    ]
    const handleFilter = (selectedOption) => {
        setSearchTerm(selectedOption)
    }
    const dateFormatter = (params) => {
        if (!params.value) return '---';
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : '---';
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        let value = momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1
        return value || '';
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setColDefs([
                {
                    headerName: t('invoiceApproval:columns.approved'), field: "isApproved", editable: false, suppressMovable: true, width: 90, pinned: 'left',
                    cellRenderer: (params) => (
                        <input
                            type="checkbox"
                            className='center'
                            style={{ width: "26.81px", height: "26.81px", border: "0.5px solid #7E57C2" }}
                            checked={params.data.isApproved}
                            disabled={searchTerm?.label === "Approved"}
                            onChange={(e) => handleCheckboxChange(params.data.voucherNo, 'isApproved', e.target.checked)}
                        />
                    )
                },
                {
                    headerName: t('invoiceApproval:columns.rejected'),
                    field: "isRejected",
                    editable: false,
                    suppressMovable: true,
                    width: 80,
                    pinned: "left",
                    cellRenderer: (params) => (
                        <input
                            type="checkbox"
                            className="center"
                            style={{
                                width: "26.81px",
                                height: "26.81px",
                                border: "0.5px solid #7E57C2",
                                cursor: params.data.isApproved ? "not-allowed" : "pointer",
                                opacity: params.data.isApproved ? 0.5 : 1,
                            }}
                            checked={params.data.isRejected}
                            disabled={searchTerm?.label === "Approved"}
                            onChange={(e) =>
                                handleCheckboxChange(
                                    params.data.voucherNo,
                                    "isRejected",
                                    e.target.checked
                                )
                            }
                        />
                    ),
                },
                {
                    headerName: t('invoiceApproval:columns.remarks'), field: "approvalRemarks", editable: true, suppressMovable: true, width: 300,
                    valueFormatter: (params) => {
                        const remarks = params?.data?.approvalRemarks
                        return (remarks === "0" ? "" : remarks);
                    }
                },
                {
                    headerName: t('invoiceApproval:columns.invoiceNo'),
                    field: "voucherNo",
                    filter: CheckboxSetFilter,
                    suppressMovable: true,
                    width: 150,
                    cellRenderer: (params) => (
                        <a
                            href="#"
                            style={{
                                color: "#1976d2",
                                textDecoration: "underline",
                                cursor: "pointer",
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handlePrint(params.data);
                            }}
                        >
                            {params.value}
                        </a>
                    )
                },
                { headerName: t('invoiceApproval:columns.property'), field: "propertyName", editable: true, suppressMovable: true, width: 120 },
                { headerName: t('invoiceApproval:columns.unitNo'), field: "unitNo", filter: CheckboxSetFilter, suppressMovable: true, width: 150 },
                { headerName: t('invoiceApproval:columns.tenant'), field: "tenantName", filter: CheckboxSetFilter, suppressMovable: true, width: 130 },
                { headerName: t('invoiceApproval:columns.contactNo'), field: "contactNo", filter: CheckboxSetFilter, suppressMovable: true, width: 130 },
                {
                    headerName: t('invoiceApproval:columns.rent'), field: "amount", filter: CheckboxSetFilter, suppressMovable: true, width: 130,
                    valueFormatter: (params) => {
                        const amount = params?.data?.amount
                        return (amount?.toFixed(3));
                    }
                },
                {
                    headerName: t('invoiceApproval:columns.vat'), field: "vat", filter: CheckboxSetFilter, suppressMovable: true, width: 120,
                    valueFormatter: (params) => {
                        const vat = params?.data?.vat
                        return (vat?.toFixed(3));
                    }
                },
                {
                    headerName: t('invoiceApproval:columns.total'), field: "invoiceTotal", filter: CheckboxSetFilter, suppressMovable: true, width: 120,
                    valueFormatter: (params) => {
                        const invoiceTotal = params?.data?.invoiceTotal
                        return (invoiceTotal?.toFixed(3));
                    }
                },
                { headerName: t('invoiceApproval:columns.approvedBy'), field: "approvedBy", filter: CheckboxSetFilter, suppressMovable: true, width: 120 },
                {
                    headerName: t('invoiceApproval:columns.approvedOn'), field: "approvedDate", filter: CheckboxSetFilter, valueFormatter: dateFormatter,
                    comparator: dateComparator, suppressMovable: true, width: 120
                },
                { headerName: t('invoiceApproval:columns.approvalList'), field: "approvalLevel", filter: CheckboxSetFilter, suppressMovable: true, width: 120 },
            ]);

            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 20);
            params.append('UserNo', userName || '');
            params.append('IsRejected', searchTerm?.label === 'Rejected' ? true : false);
            params.append('IsApproved', searchTerm?.label === 'Approved' ? true : false);
            params.append('IsPending', searchTerm?.label === 'Pending' ? true : false);
            const res = await apiService.getApiParamater('GET_INVOICE_APPROVAL', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setloader(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            // Handle error (e.g., show error message to user)
            setloader(false); // Set loading to false even in case of error
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleReset = () => {
        setloader(false);
        setFormData({ leaseNo: '' });
        setSearchTerm({ value: 'Pending', label: 'Pending' });
        navigate(location.pathname, { replace: true, state: null });
    }
    const handleRemarks = (event) => {
        const editedRow = rowData.find(row => row.voucherNo === event.data.voucherNo);
        if (editedRow) {
            editedRow[event.colDef.field] = event.value;
            setSelectedItems(prevItems => {
                const updatedItems = [...prevItems];
                const existingItemIndex = updatedItems.findIndex(item => item.docno === editedRow.voucherNo);

                if (existingItemIndex !== -1) {
                    updatedItems[existingItemIndex] = {
                        ...updatedItems[existingItemIndex],
                        [event.colDef.field]: event.value,
                    };
                } else {
                    updatedItems.push({ ...editedRow });
                }

                return updatedItems;
            });
        }
    }
    const handleCheckboxChange = async (voucherNo, field, isChecked) => {
        debugger
        // const params = new URLSearchParams();
        // params.append('Action', 'checkLeaseEditValidation');
        // params.append('LeaseNo', leaseNo);
        // const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
        // let data = res?.data?.result?.data
        // debugger
        // if (data?.length === 0) {
        setData(voucherNo, field, isChecked)
        // } else {
        //     if (data?.Invoices >= 0 && data?.Receipts === 0) {
        //         setData(leaseNo, field, isChecked)
        //     } else if (data?.Invoices > 0 || data?.Receipts > 0) {
        //         toast.warning("Invoices or Receipts created, Cannot Update Lease Status")
        //     }
        // }
    }
    const setData = (voucherNo, field, isChecked) => {
        setRowData(prevData => {
            return prevData.map(row => {
                if (row.voucherNo === voucherNo) {
                    const updatedRow = {
                        ...row,
                        isApproved: field === 'isApproved' ? isChecked : false,
                        isRejected: field === 'isRejected' ? isChecked : false
                    };

                    // Update selected items
                    setSelectedItems(prevItems => {
                        const updatedItems = [...prevItems];
                        const existingIndex = updatedItems.findIndex(item => item.voucherNo === voucherNo);

                        if (existingIndex !== -1) {
                            updatedItems[existingIndex] = { ...updatedItems[existingIndex], ...updatedRow };
                        } else {
                            updatedItems.push(updatedRow);
                        }

                        return updatedItems;
                    });

                    return updatedRow;
                }
                return row;
            });
        });

    }
    const proceedWithApiCall = async () => {
        const missingRemarks = selectedItems?.find(
            item => item.isRejected === true && (!item?.approvalRemarks || item?.approvalRemarks?.trim() === "0")
        );
        if (missingRemarks) {
            toast.error(t('invoiceApproval:remarksRequiredForRejected'));
            return;
        }
        const body = {
            approvals: selectedItems.map(item => ({
                isApproved: item.isApproved || false,
                isRejected: item.isRejected || false,
                recordId: item?.recordId,
                leaseNo: item?.voucherNo,
                approvalLevel: item?.approvalLevel,
                approvalRemarks: item?.approvalRemarks || "0",
                review: item?.review,
                reviewDept: item?.reviewDept || "0",
                reviewTo: item?.reviewTo || "0",
                reviewRemarks: item?.reviewRemarks || "0",
            })),
            modifiedBy: Name
        };
        const response = await apiService.put('POST_INVOICE_APPROVAL', body);

        if (response?.data?.statusCode === 201 || response.data.statusCode === 200) {
            toast.success(t('invoiceApproval:updatedSuccessfully'));
            getItems();
            setSelectedItems([]);
        } else {
            toast.error(t('invoiceApproval:somethingWentWrong'));
        }
    }
    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    }

    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },

                    { name: "RecordId", value: rowData?.recordId },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: rowData?.voucherNo },
                    { name: "reportName", value: 'INSTALLMENTINV' },
                ];
                debugger

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className='p-3'>
            <div className="cost-center-section">
                <div className="d-flexcursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>{t('invoiceApproval:invoicesApprovals')}</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="filter-grid">
                            <div className="filter-grid-fields">
                                <div className="filter-grid-field">
                                    <label>{t('invoiceApproval:filter')}</label>
                                    <div className="d-flex align-items-center">
                                        {StatusFilter.map((status) => (
                                            <div key={status.value} className="form-check mx-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="statusFilter"
                                                    id={status.value}
                                                    value={status.value}
                                                    checked={searchTerm.value === status.value}
                                                    onChange={() => handleFilter(status)}
                                                />
                                                <label className="form-check-label" htmlFor={status.value}>
                                                    {status.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="filter-grid-actions">
                                <div
                                    onClick={() => getItems()}
                                    className='mainbtnGry flex-end gap-2'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>{t('common:search')}</div>
                                </div>
                                {loader === true ?
                                    <div className='mainbtn flex-end gap-2'><ClipLoader color="#ffffff" size={25} /></div> :
                                    <div
                                        onClick={() => proceedWithApiCall()}
                                        className='mainbtn flex-end gap-2'>
                                        <FaSave color='#fff' className='center mt-2 mx-2' />
                                        <div className='center'>{t('common:save')}</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleReset()}
                                    className='mainbtnRed flex-end gap-2'>
                                    <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>{t('common:reset')}</div>
                                </div>
                                <div
                                    onClick={() => handleBackClick()}
                                    className='mainbtn flex-end gap-2'>
                                    <FaAngleLeft color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>{t('common:back')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>{t('invoiceApproval:approvalList')}</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${SupplierTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                onCellValueChanged={handleRemarks}
                                suppressRowClickSelection={true}
                                getRowStyle={(params) => {
                                    return params.node.rowIndex % 2 === 0
                                        ? { background: '#F0EDF5' }
                                        : { background: '#fff' };
                                }}
                            />
                        </div>
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default LeaseInvoiceApproval;
